import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

export const useResourcesUsers = () => {
  const workers = useSelector((state) => state.schedule.resources.workers);
  const usedWorkers = useSelector((state) => state.schedule.availability.assignedWorkers);
  const workersInitialized = useMemo(() => workers !== null, [workers]);
  const [userList, setUserList] = useState(null);

  useEffect(() => {
    if (!workersInitialized) return setUserList(null);
    if (!usedWorkers) return setUserList(workers);
    setUserList(
      workers.map((user) => ({
        ...user,
        isUsed: !!usedWorkers.find((usedWorkerId) => usedWorkerId === user._id),
      }))
    );
  }, [workers, usedWorkers, workersInitialized]);

  return { userList };
};
